import Tracker from "./Tracker";

class FirebaseTracker extends Tracker {
  constructor(firebase, options) {
    super(options);
    this.isSupported = false;

    if (!this.debug) {
      firebase.analytics.isSupported().then(supported => {
        this.isSupported = supported;

        if (supported) {
          this.setLogger(firebase.analytics());
        }
      }).catch(() => {
        this.isSupported = false;
      });
    }
  }

  logEvent(payload) {
    // log event only if in prod mode analytics supports by firebase or debug mode is turned on
    if (this.isSupported || this.debug) {
      return super.logEvent(payload);
    } // do nothing

  }

}

export default FirebaseTracker;